import type { TablePiece } from '@v2/sdk'
import { FaceArt } from './FaceArt'
import { Icon } from './icons'
import { pieceLabel } from './piece-label'
import './peek-inspector.css'

/** The renderer magnifies the actual piece; DOM supplies accessibility and dismissal. */
export function PeekInspector({ piece, onClose, fallback = false }: { piece: TablePiece; onClose?: () => void; fallback?: boolean }) {
  const label = pieceLabel(piece)
  return <aside className={`tt-peek-inspector${onClose ? ' is-pinned' : ''}`} role={onClose ? 'dialog' : 'tooltip'} aria-label={onClose ? 'A closer look' : `Inspect ${label}`} data-testid={onClose ? 'pinned-inspector' : 'peek-inspector'} onClick={onClose}>
    <span className="tt-sr-only">{label}</span>
    {piece.count !== undefined && <div className="tt-inspection-count">{label} · {piece.count}</div>}
    {fallback && <div className="tt-inspection-fallback"><FaceArt art={piece.hidden ? piece.back : piece.face} label={label} hidden={piece.hidden} color={piece.hidden ? piece.back?.color : piece.color}/></div>}
    {onClose && <button type="button" className="tt-inspection-close" aria-label="Close A closer look" onClick={event => { event.stopPropagation(); onClose() }}><Icon name="close" size={20}/></button>}
  </aside>
}
